import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'split-appointment-card',
  templateUrl: './split-appointment-card.component.html',
  styleUrls: ['./split-appointment-card.component.scss']
})
export class SplitAppointmentCardComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() day = '';
  @Input() time = '';
  @Input() color = '';
  @Input() tooltip = '';

  @Output() valueChange = new EventEmitter();

  
}